import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BackendService} from "../backend/backend.service";

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  public keys = {
    'cap': ['less than 100k', '100k-1M', '1M-10M', 'more than 10M'],
    'hr': ['large (>200)', 'micro (1-10)', 'small (11-50)', 'medium (51-200)'],
    'date': ['-2000', '2001-2010','2010+']
  };

  public sortValue = {
    'hr': { 'micro (1-10)':0,  'small (11-50)': 1, 'medium (51-200)': 2, 'large (>200)': 3},
    'cap': { 'less than 100k': 0, '100k-1M':1, '1M-10M':2, 'more than 10M':3 }
  };

  constructor( private http: HttpClient, private backendService: BackendService) {}

  public readAll(){
    return  this.backendService.read('companies');
  }


  public numberByYear(dat, ctrs, four = false){
    let data = JSON.parse( JSON.stringify(dat));


    if(four){
      data.map( d => {
        if( d['date'] ) {
          d['date'] = this.toDateFour(d['date']);
        }
      });
    }


    let re = this.backendService.filterBy(data, {'hq': ctrs});
    data = this.backendService.groupBy(re, 'date', 'hq');

    let res = { data: [], labels: []};

    // ------- define labels
    let labels = [];
    for( let clust of data){
      labels = labels.concat(clust['series'].map(d => d['name']))
    }
    labels = Array.from(new Set(labels)).sort();
    for( let l = Number(labels[0]); l<Number(labels[-1]); l++ ){
      if( !labels.includes(l.toString())){
        labels.push( l.toString() );
      }
    }
    labels = labels.sort();

    res['labels'] = labels;

    for( let clust of data ){
      let dd = {data : [], label: clust['name']};

      let cum = 0;
      for ( let l of labels){
        if( !clust['series'].map( d => d['name']).includes( l ) ){
          cum += 0;
          dd['data'].push(cum);
        } else{
          cum += clust['series'].filter(d => d['name'] === l )[0]['value'];
          dd['data'].push( cum );
        }
      }
      res['data'].push(dd);
    }

    console.log(res);

    return  res;
  }


  public numberByHq(data, ctrs){
    let re = this.backendService.filterBy(data, {'hq': ctrs});
    re = this.backendService.countBy(re, 'hq');
    let su = 0;
    re.map(d => su += d['value']);

    return {data: [(re.map(d => parseFloat(((d['value'] / su)*100).toFixed(2)) ))] , labels:  re.map(d => d['name'])};
  }


  public numberByHr( dat ) {
    let data = JSON.parse(JSON.stringify(dat));
    data.map( d =>{
      if(d['hr']){
        d['hr'] = this.toHrFour(d['hr'])
      }
    } );

    let res = this.backendService.countBy(data, 'hr');
    let su = 0;
    res.map(d => su += d['value']);

    res.sort( (a, b) => this.sortValue['hr'][a['name']] - this.sortValue['hr'][b['name']]);
    return {data: [res.map(d => parseFloat(((d['value'] / su)*100).toFixed(2)))] , labels:  res.map(d => d['name'])};
  }


  public numberByCap( dat ) {
    let data = JSON.parse(JSON.stringify(dat));
    data.map( d =>{
      if(d['capital']){
        d['capital'] = this.toCapFour(d['capital'])
      }
    } );

    let res = this.backendService.countBy(data, 'capital');
    let su = 0;
    res.map(d => su += d['value']);

    res.sort( (a, b) => this.sortValue['cap'][a['name']] - this.sortValue['cap'][b['name']]);
    return {data: [res.map(d => parseFloat(((d['value'] / su)*100).toFixed(2)) ) ] , labels:  res.map(d => d['name'])};
  }


  public filterBy( data, filters ){
    for( let k in filters){
      if( filters[k].length === 0 ) { continue;}
      if(k === 'tags'){

        data = data.filter(d => (d['tags'] !== '') && (d['tags'] !== undefined) ).filter(d => d['tags'].split(',').filter( dd => filters['tags'].includes(dd.trim())).length !== 0);
        //data = data.filter(d => filters[k].includes(d[k]) );
      }else{
        data = data.filter(d => filters[k].includes(d[k]) );
      }
    }
    //console.log(data);
    return data;
  }


  public getCol(data, col){
    return this.backendService.getCol(data, col);
    let res = Array.from(new Set(data.map(d => d[col])).values());
    if(col === 'tags'){
      res = Array.from(new Set(res.join(',').split(',').map(d => d.trim())));
    }
    return res.filter(d => d !== '' && d !== undefined).sort() ;
  }

  public toHrFour(hr) {
    //return hr;
    let lr = hr.split('-');
    if( hr === '10001+' ) { return 'large (>200)';}
    if( Number(lr[1]) <= 10 ) { return 'micro (1-10)';}
    if( Number(lr[1]) === 50 ){ return 'small (11-50)';}
    if( Number(lr[1]) === 200 ){ return 'medium (51-200)';}
    if( Number(lr[0]) > 200 ){ return 'large (>200)';}
    console.log('not reached', hr);
  }

  public toCapFour(cap) {
    const c = Number(cap);
    if ( cap <= 100000){ return 'less than 100k';}
    if( cap >= 100000 && cap <= 1000000){return '100k-1M';}
    if( cap >= 1000000 && cap <= 10000000){return '1M-10M';}
    return 'more than 10M';
  }

  public toDateFour(date) {
    //return date;
    const d = Number(date);
    if( d <= 2000) {return '-2000';}
    if( d > 2000 && d <= 2010) { return '2001-2010';}
    if( d > 2010) {return '2010+';}
  }


}
